import React from "react";
import { GreyImageStyle } from "./style";
import impact from "../../images/impact-report.png";

const GreyImage = () => {
  return (
      <GreyImageStyle background={impact}>
    </GreyImageStyle>
  );
};

export default GreyImage;
